import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_14: FaireProductEntity = {
  token: "caden-lane-14",
  type: "product",
  name: "Full Length Ruffle Nightgown | Berry Sweet",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/3edb85842405de538219519ab075b324f06981c8c844702cf36aa3af64128863.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 21,
  msrpDollars: 42,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
